import React, { useEffect, useState } from 'react'
import { Button, Checkbox, FormControlLabel, FormGroup, Grid, TextField, Typography } from '@mui/material'
import { useLocation, useNavigate } from 'react-router'
import ArrowBackOutlinedIcon from '@mui/icons-material/ArrowBackOutlined';
import Sidebar from './components/Sidebar';
import SyncIcon from '@mui/icons-material/Sync';
import i18next from 'i18next';
import FormQuestions from './components/FormQuestions';
import swal from 'sweetalert';
import { postApi } from './api/services';
import { serviceDown } from './utils/UtilityFunctions';
import MainLoader from './components/MainLoader';
import imgurl from './assests/images/imgurl';
import SearchIcon from "@mui/icons-material/Search";

const Orders = () => {

  const navigate = useNavigate()
  const location = useLocation()
  const [isLoading, setIsLoading] = useState(false)
  const [orderList, setOrderList] = useState([])
  const [tempOrderList, setTempOrderList] = useState([])
  const [isRotating, setIsRotating] = useState(false);

  useEffect(() => {
    getOrderList()
  }, [])

  const getOrderList = async () => {
    setIsLoading(true)
    let emailAddress = JSON.parse(localStorage.getItem('doctorobj'))?.clinic_email
    let params = {
      email: emailAddress
    }
    console.log("fetch_orders params", params);
    try {
      let res = await postApi('fetch_orders', params)
      if(res.error) {
        setIsLoading(false)
        setOrderList([])
        setTempOrderList([])
      } else {
        console.log("fetch_orders res", res);
        setIsLoading(false)
        let ordersArr = res.orders.map((order) => {
          const prescriptionNumber = order.customer_note.match(/Prescription Number\s+([A-Z0-9]+)/i)?.[1] || "";
          const patientName = order.customer_note.match(/Patient Name:\s*([^\n]+)/i)?.[1].trim() || "";
          const doctorName = order.customer_note.match(/Doctor Name:\s*([^\n]+)/i)?.[1].trim() || "";
          const dosage = order.customer_note.match(/Dosage prescribed:\s*([^\n]+)/i)?.[1].trim() || "";
          return {
            ...order,
            customer_details: {
              prescription_number: prescriptionNumber,
              patient_name: patientName,
              doctor_name: doctorName,
              dosage: dosage
            }
          };
        })
        console.log("ordersArr", ordersArr);
        setOrderList(ordersArr)
        setTempOrderList(ordersArr)
      }
    } catch (err) {
      setIsLoading(false)
      console.log("err", err);
      serviceDown()
    }
  }

  const handleRotate = () => {
    setIsRotating(true);  
    getOrderList()
  };

  const searchOrder = async (value) => {
    const query = value.trim();
    if(query === ''){
      setOrderList(tempOrderList)
      return
    } else {
      let filteredArr = tempOrderList.filter((order) => 
        order?.customer_details?.patient_name?.toUpperCase().includes(query.toUpperCase())
      )
      console.log("filteredArr", filteredArr);
      setOrderList(filteredArr)
    }
  }

  return (
    <>
      {isLoading && <MainLoader/>}
      <div className='orderspage photo-container main-section-container'>
        <Grid container spacing={0} className='d-flex justify-content-start align-items-center'>
          <Grid item xs={1} className=''>
            <div className='d-flex justify-content-start align-items-center'>
              <span className='backButtonDiv' onClick={() => navigate('/clients')}>
                <ArrowBackOutlinedIcon className='arrowBackBtn'></ArrowBackOutlinedIcon>
              </span>
            </div>
          </Grid>
          <Grid item xs={9} className='d-flex justify-content-center align-items-center '>
            <Typography variant="h6" className="title">{i18next.t("Orders")}</Typography>
          </Grid>
          <Grid item xs={1} onClick={handleRotate} className="cursor-pointer">
            <SyncIcon className={isRotating ? "rotate-once" : ""} />
          </Grid>
          <Grid item xs={1}>
            <Sidebar/>
          </Grid>
        </Grid>
        {
          orderList.length > 0 &&
            <Grid container spacing={0} className="d-flex justify-content-center align-items-center searchDiv mt-5px mb-10px">
              <Grid item xs={12} className="d-flex justify-content-end align-items-center">
                <TextField
                  type="search"
                  className="searchInput w-100"
                  onChange={(e) => searchOrder(e.target.value)}
                  placeholder={i18next.t("Enter name to search")}
                  InputProps={{
                    startAdornment: <SearchIcon className=" mr-5px" />
                  }}
                />
              </Grid>
            </Grid>
        }
        <div className='orderspage-questions-container'>
          {
            orderList.length > 0 ? 
              orderList.map((order, index) => (
                <Grid container spacing={0} className='order-card d-flex justify-content-center align-items-center orderContainer' key={index}>
                  <Grid item xs={12} className='d-flex justify-content-start align-items-center flex-direction-column orderContainerCard'>
                    <div className='d-flex justify-content-space-between align-items-start w-100'>
                      <p><span className='p-main'>{i18next.t('Order ID: ')}</span>{`${order.order_id}`}</p>
                      <p className='text-capitalize'><span className='p-main'>{i18next.t('Status: ')}</span>{`${order.status}`}</p>
                    </div>
                    <p className='w-100 text-left'><span className='p-main'>{i18next.t('Patient Name: ')}</span>{`${order.customer_details.patient_name}`}</p>
                    <p className='w-100 text-left'><span className='p-main'>{i18next.t('Prescription ID: ')}</span>{`${order.customer_details.prescription_number}`}</p>
                    <p className='w-100 text-left'><span className='p-main'>{i18next.t('Dosage: ')}</span>{`${order.customer_details.dosage}`}</p>
                  </Grid>
                </Grid>
              )) 
               :
              <div className="nodatadiv">
                <div className="nodatafoundimg">
                  <img src={imgurl.emptycart} />
                </div>
                <Typography className="">
                  {i18next.t("No orders found")}
                </Typography>
              </div>
          }
        </div>
      </div>
    </>
  )
}

export default Orders